import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
// import PrograssBar from "../Dashboard/PrograssBar";
import Zoom from "react-medium-image-zoom";
import { Button } from "@mui/material";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import CheckIcon from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
// import { PieChart } from "react-minimal-pie-chart";
// import DeleteIcon from "@mui/icons-material/Delete";
import ReplayCircleFilledIcon from "@mui/icons-material/ReplayCircleFilled";
// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import PieChartPage from "./PieChartPage";
// import BarChartPage from "./BarChartPage";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import avtarPic from "../../../assets/Images/avtarPic.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SortIcon from "@mui/icons-material/Sort";
// import Chart from "react-apexcharts";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
// import { Pie } from "react-chartjs-2";
// import { ArcElement } from "chart.js/dist";
import reecordNotFound from "../../../assets/Images/noData2.gif";
import Pagination from '@mui/material/Pagination';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Validation_Schema = Yup.object().shape({
  poleTopic: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required"),
  poleDesc: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required"),
  option1: Yup.string().required("Required"),
  option2: Yup.string().required("Required"),
  // poleStartDate: required("Required"),
  // setPoleEndDate: required("Required"),
});
var formikInitials = {
  poleTopic: "",
  poleDesc: "",
  poleOptionsList: [],
  option1: "Yes",
  option2: "No",
  // poleStartDate:new Date(),
};

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement
);

function PollsPage() {
  // const navigate = useNavigate();

  // For Date And Time Picker 2
  const [, setValue2] = React.useState(dayjs("2014-08-18T21:11:54"));

  // End

  // For Date And Time Picker 3
  // const [value3, setValue3] = React.useState(dayjs("2014-08-18T21:11:54"));

  const [value, setValue] = React.useState(0);

  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");
  // const descriptionElementRef = React.useRef(null);

  const [open3, setOpen3] = React.useState(false);
  const [, setScroll3] = React.useState("paper");

  // const descriptionElementRef1 = React.useRef(null);
  const [pollsList, setPollsList] = React.useState([]);
  // const [, setClosePollsList] = React.useState([]);

  const [poleTopic, setPoleTopic] = React.useState("");
  const [poleDesc, setPoleDesc] = React.useState("");
  const [poleStartDate, setPoleStartDate] = React.useState(dayjs(new Date()));
  const [poleEndDate, setPoleEndDate] = React.useState(dayjs(new Date()));

  const [poleOptionsList, setPoleOptionsList] = React.useState([]);
  const [option1, setOption1] = React.useState("Yes");
  const [option2, setOption2] = React.useState("No");

  const [group_name, setGroupName] = React.useState("");
  const [group_description, setGroupDesc] = React.useState("");
  // const [group_pic, setGroupPic] = React.useState();
  // const [is_public, setIsPublic] = React.useState();
  const [residentlist, setresidentlist] = React.useState([]);
  const [membersIds, setMembersIds] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [groupsList, setGroupsList] = React.useState([]);
  const [selectedGroup, setSelectedGroup] = React.useState("");
  const [radiovalue, setradioValue] = React.useState("");
  const [isSelectGroup, setIsSelectGroup] = React.useState(false);
  // const [isUserVoted, setIsUserVoted] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState("");
  const [errmsgradiobtn, seterrmsgradiobtn] = React.useState(false);
  const [count] = React.useState(0);
  const [, setActiveIndex] = React.useState();
  // const [Update, setUpdate] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [status, setStatus] = React.useState("open");
  const [sort, setSort] = React.useState("newtoold");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  // const [update, setupdate] = React.useState(false);

  const [PollsResultView, setPollsResultView] = React.useState(false);
  const [getPoll_id, setPoll_id] = React.useState();
  const [getGraph, setGraph] = React.useState([]);
  const [showerr, setshowerr] = React.useState(false);

  const [graphdetilData, setgraphdetilData] = React.useState({
    yesdata: [],
    nodata: [],
  });
  const [polltitle, setpolltitle] = React.useState("");
  const [ressearch, setressearch] = React.useState("");

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(3);
  const [totalItems, setTotalItems] = React.useState(0);

  let memberArr = [];

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  async function getAllpolls() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      sort: sort,
      pageNo: currentPage,
      count: itemsPerPage,
      status: status,
    };
    await makePostRequest("polls/getAllPolls", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          setPollsList(response.data.data.data);
          setTotalItems(response.data.data.total_records);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  // async function GetAllClosePolls() {
  //   setShowLoader(true);
  //   let bodyFormData = {
  //     searchq: q,
  //     sort: "newtoold",
  //     pageNo: 1,
  //     count: 100,
  //   };
  //   await makePostRequest("polls/getAllClosePolls", bodyFormData)
  //     .then((response) => {
  //       if (response.status === 201) {
  //         setClosePollsList(response.data.data.rows);
  //         setShowLoader(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setShowLoader(false);
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }
  async function GetAllGroups() {
    await makeGetRequest("group/getAllGroups/" + localStorage.getItem("userId"))
      .then((response) => {
        if (response.status === 201) {
          setGroupsList(response.data.data.rows);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangePoleStartDate = (newValue) => {
    // if (newValue >= moment()) {
    setPoleStartDate(newValue);
    // }
    // else {
    //   swal(
    //     "Invalid Date!",
    //     "please select a date greater than start date of duty",
    //     "warning"
    //   );
    // }
  };

  const handleChangePoleEndDate = (newValue) => {
    setPoleEndDate(newValue);
  };

  // const handleChangePoleStartDate = (date) => {

  //   if (date.format("DD MM YYYY") >= moment().format("DD MM YYYY")) {
  //     setPoleStartDate(date);

  //     if (date.format("DD MM YYYY") == moment().format("DD MM YYYY")) {
  //       if (date.format("HH") >= moment().format("HH")) {
  //         setPoleStartDate(date);
  //         if (date.format("HH") == moment().format("HH")) {
  //           if (date.format("mm") >= moment().format("mm")) {
  //             setPoleStartDate(date);
  //           }
  //           else {
  //             swal(
  //               "Invalid Time!",
  //               "Unable to select past time",
  //               "warning",
  //               {
  //                 timer: 3000,
  //                 buttons: false,
  //               }
  //             );
  //             setPoleStartDate(new Date())
  //           }
  //         }
  //       }
  //       else {
  //         swal(
  //           "Invalid Time!",
  //           "Unable to select past time",
  //           "warning",
  //           {
  //             timer: 3000,
  //             buttons: false,
  //           }
  //         );
  //         setPoleStartDate(new Date());
  //       }
  //     }
  //   }
  //   else {
  //     swal(
  //       "Invalid Date!",
  //       "Unable to select past date",
  //       "warning",
  //       {
  //         timer: 3000,
  //         buttons: false,
  //       }
  //     );
  //     setPoleStartDate(new Date())
  //   }
  // };

  // const handleChangePoleEndDate = (date) => {
  //   if (date.format("DD MM YYYY") >= poleStartDate.format("DD MM YYYY")) {
  //     setPoleEndDate(date);

  //     if (date.format("DD MM YYYY") == poleStartDate.format("DD MM YYYY")) {
  //       if (date.format("HH") >= poleStartDate.format("HH")) {
  //         setPoleEndDate(date);
  //         if (date.format("HH") == poleStartDate.format("HH")) {
  //           if (date.format("mm") >= poleStartDate.format("mm")) {
  //             setPoleEndDate(date);
  //           }
  //           else {
  //             swal(
  //               "Invalid Time!",
  //               "Unable to select past time",
  //               "warning",
  //               {
  //                 timer: 3000,
  //                 buttons: false,
  //               }
  //             );
  //             setPoleEndDate(new Date())
  //           }
  //         }
  //       }
  //       else {
  //         swal(
  //           "Invalid Time!",
  //           "Unable to select past time",
  //           "warning",
  //           {
  //             timer: 3000,
  //             buttons: false,
  //           }
  //         );
  //         setPoleEndDate(new Date());
  //       }
  //     }
  //   }
  //   else {
  //     swal(
  //       "Invalid Date!",
  //       "Unable to select past date",
  //       "warning",
  //       {
  //         timer: 3000,
  //         buttons: false,
  //       }
  //     );
  //     setPoleEndDate(new Date())
  //   }
  // };

  async function createPole() {
    if (poleOptionsList.length === 0) {
      poleOptionsList.push(option1);
      poleOptionsList.push(option2);
      setPoleOptionsList(poleOptionsList);
    }

    if (radiovalue === "") {
      seterrmsgradiobtn(true);
      return false;
    } else {
      seterrmsgradiobtn(false);

      const sDate = new Date(poleStartDate);
      const eDate = new Date(poleEndDate);

      if (eDate > sDate) {
        if (
          radiovalue === "all" ||
          radiovalue === "committeeMembers" ||
          radiovalue === "allOwners"
        ) {
          setShowLoader(true);

          let bodyFormData = "";

          await makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
            .then((response) => {
              if (response.status === 201) {
                for (var i = 0; i < response.data.data.length; i++) {
                  memberArr.push(response.data.data[i].resident_id);
                }
                setMembersIds(memberArr);

                let inputdata;
                inputdata = {
                  polltopic: poleTopic,
                  poll_option: poleOptionsList,
                  description: poleDesc,
                  poll_start_datetime: poleStartDate,
                  poll_expiry_datetime: poleEndDate,
                  resident_id: parseInt(localStorage.getItem("userId")),
                  member_id_list: memberArr,
                  status: "open",
                };
                if (selectedGroup) inputdata.group_id = selectedGroup;
                else inputdata.group_id = 0;

                makePostRequest("polls/insert", inputdata)
                  .then((response) => {
                    if (response.status === 201) {
                      swal("Success", "Poll created Successfully", "success", {
                        timer: 1000,
                        buttons: false,
                      });

                      // window.location.reload();
                      setOpen2(false);
                      setShowLoader(false);
                      getAllpolls();
                    }
                  })
                  .catch((err) => {
                    setShowLoader(false);
                    swal("There was an error!", "more error details", "warning");
                  });
              } else {
                setShowLoader(false);
                swal("There was an error!", response.message, "warning");
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });
        } else {
          if (membersIds.length > 0 && radiovalue === "Groups") {
            setshowerr(false);
            let inputdata;
            inputdata = {
              polltopic: poleTopic,
              poll_option: poleOptionsList,
              description: poleDesc,
              poll_start_datetime: poleStartDate,
              poll_expiry_datetime: poleEndDate,
              resident_id: parseInt(localStorage.getItem("userId")),
              member_id_list: memberArr,
              status: "open",
            };
            if (selectedGroup) inputdata.group_id = selectedGroup;
            else inputdata.group_id = 0;

            await makePostRequest("polls/insert", inputdata)
              .then((response) => {
                if (response.status === 201) {
                  swal("Success", "Poll created Successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });

                  // window.location.reload();
                  setOpen2(false);
                  setShowLoader(false);
                  getAllpolls();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
          } else {
            setshowerr(true);
          }
        }
      } else {
        swal("Invalid Time!", 'Poll end time should be greater than start time', "warning");
      }
    }
  }

  async function createGroup() {
    if (group_name === "" || group_name === undefined) {
      swal("warning", "Group name should not be empty", "warning");
      return false;
    } else if (group_description === "" || group_description === undefined) {
      swal("warning", "Description should not be empty", "warning");
      return false;
    } else if (membersIds.length === 0) {
      swal("warning", "Please select at least one member", "warning");
      return false;
    } else {
      setShowLoader(true);
      let inputdata;
      inputdata = {
        group_name: group_name,
        group_description: group_description,
        resident_id: parseInt(localStorage.getItem("userId")),
      };
      await makePostRequest("group/createGroup", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            let groupData = {
              group_id: response.data.data.group_id,
              member_id: membersIds,
            };
            makePostRequest("group/addGroupMember", groupData)
              .then((response) => {
                if (response.data.status === "1") {
                  swal("Success", "Group created successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  setGroupName("");
                  setGroupDesc("");
                  setOpen3(false);
                  // setOpen2(true);
                  setShowLoader(false);
                  GetAllGroups();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  async function residentlisting() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: ressearch,
      pageNo: "",
      count: "",
      isTenent: "",
    };

    await makePostRequest("resident/residentandtenentlisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.rows;
          setresidentlist(data);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangeSelectedResident = (residentId) => {
    // membersIds.push(residentId);
    // setMembersIds(membersIds);
    setshowerr(false);
    setMembersIds((memIds) => {
      const index = memIds.indexOf(residentId);
      if (index !== -1) {
        //remove
        const updatedIds = [...memIds];
        updatedIds.splice(index, 1);
        return updatedIds;
      } else {
        //add
        return [...memIds, residentId];
      }
    });
    setActiveIndex(residentId);
  };

  const handleChangeradio = (e) => {
    seterrmsgradiobtn(false);
    setshowerr(false);
    memberArr.length = 0;
    membersIds.length = 0;
    let selectedVal = e.target.value;

    //  let userFlag = "";
    setradioValue(selectedVal);
    if (selectedVal === "Groups") {
      setIsSelectGroup(true);
      GetAllGroups();
    } else {
      let userFlag;
      setIsSelectGroup(false);
      if (e.target.value === "Committee Members") {
        userFlag = "CommitteeMem";
      } else {
        userFlag = selectedVal;
      }
      console.log(userFlag)
      // let bodyFormData = "";

      // makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
      //   .then((response) => {
      //     if (response.status === 201) {
      //       for (var i = 0; i < response.data.data.length; i++) {
      //         memberArr.push(response.data.data[i].resident_id);
      //       }
      //       setMembersIds(memberArr);
      //     } else {
      //       swal("There was an error!", response.message, "warning");
      //     }
      //   })
      //   .catch((err) => {
      //     swal("There was an error!", "more error details", "warning");
      //   });
    }
  };
  const handleChangeOption = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleClickOpen3 = (scrollType) => () => {
    // setSelectedGroup();
    memberArr.length = 0;
    membersIds.length = 0;
    setOpen3(true);
    // setOpen2(false);
    setScroll3(scrollType);
    // setradioValue("");
  };

  const handleClose3 = () => {
    setGroupName("");
    setGroupDesc("");
    setOpen3(false);
    // setOpen2(true);
  };
  const handleClickOpen2 = (scrollType) => () => {
    residentlisting();

    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const voteDetails = async (pollId) => {
    setgraphdetilData({ yesdata: [], nodata: [] });
    setOpen(true);
    // return false;
    await makeGetRequest("polls/getpollgraphdata/" + pollId)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data);
          if (response.data.data) {
            const newData = {
              yesdata: response.data.data.yesdata,
              nodata: response.data.data.nodata,
            };
            setgraphdetilData(newData);
          } else {
            setgraphdetilData({ yesdata: [], nodata: [] });
          }
        } else {
          setgraphdetilData({ yesdata: [], nodata: [] });
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  };

  // const[dataa1 , setdataa1]=useState([]);
  let clkindex = null;
  const Labels = getGraph.map((data) => data.label);
  const datavals = getGraph.map((val) => val.value);

  const viewRsltClick = (poll_id, polltopic, index) => {
    // alert(poll_id)
    setGraph([]);
    // clkindex = (clkindex === index) ? null : index

    // const priv = document.querySelector('.pollResultDiv.pollResultDivExpand')
    // if (priv) {
    //   priv.classList.remove('pollResultDivExpand')
    // }
    // clkindex = index
    // const curr = document.getElementById("myResult" + index);

    // if (curr) {
    //   curr.classList.add('pollResultDivExpand')
    // }

    setPollsResultView(!PollsResultView);
    setPoll_id(poll_id);
    setpolltitle(polltopic);
    let usearry = pollsList;
    const desiredObject = usearry.find((obj) => obj.poll_id === poll_id);
    let countval = 0;
    let countno = 0;
    if (desiredObject.pollobj != null) {
      let pobject = desiredObject.pollobj;
      pobject.forEach((obj) => {
        console.log(obj);
        if (obj.Yes == "Yes") {
          countval = obj.id.split(",").length;
        } else {
          countno = obj.id.split(",").length;
        }
      });
      let barData1 = [
        { value: countval, frontColor: "#00A02C", label: "Yes" },
        { value: countno, frontColor: "#F03939", label: "No" },
      ];

      console.log("barData1", barData1);
      setGraph(barData1);
    } else {
      // alert("in else")
      setGraph([]);
      countval = 0;
    }
  };

  const BarChartData = {
    labels: Labels,
    // dataid:Labels1,
    datasets: [
      {
        label: "Votes",

        // barPercentage: 0.90,
        barThickness: 50,
        backgroundColor: "#4A2FB8",
        borderColor: "rgba(0,0,0,1)",
        data: datavals,
        fill: false,
      },
    ],
  };

  // voting details
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChange2 = (newValue) => {
    setValue2(newValue);
  };
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (e) => {
    setSort(e.currentTarget.dataset.myValue);
    setAnchorEl(null);
  };
  const { useState } = React;
  const AddedElement = () => (
    <>
      <li>
        <div className="pollOptionHedAddInput">
          <input className="modalInputStSelect" />
          <CloseOutlinedIcon onClick={removeList} />
        </div>
      </li>
    </>
  );

  // End

  const removeList = () => {
    // var myList = document.getElementById("myList");
    // var items = document.querySelectorAll("#myList li");
    // myList.removeChild(items[items.length - 1]);
  };

  const handleChangeGroup = async (e) => {
    setSelectedGroup(e.target.value);
    setShowLoader(true);
    setshowerr(false);
    await makeGetRequest("group/getgroupmember/" + e.target.value)
      .then((response) => {
        if (response.status === 201) {
          setMembersIds(response.data.data.member_id);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  // const[lstResidentVoted,setLstResidentVoted]=React.useState([]);

  //old code
  // async function AddPollVote(pollObject) {
  //   console.log(pollObject)
  //   // return;
  //   // let arrOptionSelected = [];
  //   //   let newPollObj = {};
  //   //   newPollObj.id = localStorage.getItem("userId");
  //   //   newPollObj[selectedOption] = selectedOption;

  //   //   arrOptionSelected.push(newPollObj);
  //   //   console.log(arrOptionSelected);
  //   //   console.log(selectedOption)
  //   // return false
  //   // alert(option1)
  //   const currentDate = new Date();
  //   const targetDate = new Date(pollObject.poll_start_datetime);
  //   console.log(selectedOption);
  //   if (!selectedOption) {
  //     await swal({
  //       title: "Select option",
  //       text: `For vote please select option.`,
  //       icon: "warning",
  //       buttons: true,
  //       dangerMode: true,
  //     });
  //     return false;
  //   }

  //   if (targetDate > currentDate) {
  //     await swal({
  //       title: "warning",
  //       text: `Polling is not started yet.`,
  //       icon: "warning",
  //       buttons: true,
  //       dangerMode: true,
  //     });
  //     setSelectedOption("");
  //     return false;
  //   }
  //   const willDelete = await swal({
  //     title: "Are you sure?",
  //     text: `Do you really want to vote? This process cannot be undone.`,
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   });

  //   if (willDelete) {
  //     let arr = [];
  //     if (pollObject.pollcount_id) {
  //       console.log('in if')
  //       return
  //       arr = pollObject.pollobj;

  //       const obj = arr.find((item) => item.hasOwnProperty(selectedOption));
  //       if (obj) {
  //         let indexOfObject = pollObject.pollobj.indexOf(obj);
  //         let newObj = obj.id + "," + localStorage.getItem("userId");

  //         let newPollObj = {};
  //         newPollObj.id = newObj;
  //         newPollObj[selectedOption] = selectedOption;
  //         arr[indexOfObject] = newPollObj;
  //       } else {
  //         let newPollObj = {};
  //         newPollObj.id = localStorage.getItem("userId");
  //         newPollObj[selectedOption] = selectedOption;
  //         arr.push(newPollObj);
  //       }

  //       let pollCountData = {
  //         pollcount_id: pollObject.pollcount_id,
  //         polls_id: pollObject.poll_id,
  //         pollobj: arr,
  //       };

  //       await makePostRequest("polls/updatePollCount", pollCountData)
  //         .then((response) => {
  //           if (response.data.status === "1") {
  //             // swal("Success", "Group created successfully", "success", {
  //             //   timer: 1000,
  //             //   buttons: false,
  //             // });
  //             setSelectedOption("");
  //             // setIsUserVoted(true);
  //             getAllpolls();
  //           }
  //         })
  //         .catch((err) => {
  //           swal("There was an error!", "more error details", "warning");
  //         });
  //     } else {
  //       console.log('in else')
  //       return
  //       //Create PollCount Object and add vote

  //       let arrOptionSelected = [];
  //       let newPollObj = {};
  //       newPollObj.id = localStorage.getItem("userId");
  //       newPollObj[selectedOption] = selectedOption;

  //       arrOptionSelected.push(newPollObj);
  //       let pollCountData = {
  //         // pollcount_id:pollObject.pollcount_id,
  //         polls_id: pollObject.poll_id,
  //         pollobj: arrOptionSelected,
  //       };

  //       await makePostRequest("polls/insertcount", pollCountData)
  //         .then((response) => {
  //           if (response.data.status === "1") {
  //             setSelectedOption("");
  //             // setIsUserVoted(true);
  //             // setUpdate(!Update);
  //             getAllpolls();
  //           }
  //         })
  //         .catch((err) => {
  //           swal("There was an error!", "more error details", "warning");
  //         });
  //     }
  //   } else {
  //     // alert('cancel')
  //     setSelectedOption("");
  //     // setupdate(!update)
  //   }
  // }




  // for vote issue resolve

  async function AddPollVote(pollObject) {
    console.log(pollObject)
    // return;
    // let arrOptionSelected = [];
    //   let newPollObj = {};
    //   newPollObj.id = localStorage.getItem("userId");
    //   newPollObj[selectedOption] = selectedOption;

    //   arrOptionSelected.push(newPollObj);
    //   console.log(arrOptionSelected);
    //   console.log(selectedOption)
    // return false
    // alert(option1)
    const currentDate = new Date();
    const targetDate = new Date(pollObject.poll_start_datetime);
    console.log(selectedOption);
    if (!selectedOption) {
      await swal({
        title: "Select option",
        text: `For vote please select option.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      return false;
    }

    if (targetDate > currentDate) {
      await swal({
        title: "warning",
        text: `Polling is not started yet.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      setSelectedOption("");
      return false;
    }
    const willDelete = await swal({
      title: "Are you sure?",
      text: `Do you really want to vote? This process cannot be undone.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      let arr = [];
      // for chk pollobj present or not

      await makeGetRequest("polls/getpollobjbyid/" + pollObject.poll_id)
        .then((response) => {
          if (response.status == "201") {
            console.log('data', response.data.data.length)
            if (response.data.data.length > 0) {

              let objdata = response.data.data[0].pollobj;
              let pollcountid = response.data.data[0].polls_id;
              console.log('data', objdata)

              // object present
              arr = objdata;

              const obj = arr.find((item) => item.hasOwnProperty(selectedOption));
              if (obj) {
                let indexOfObject = objdata.indexOf(obj);
                let newObj = obj.id + "," + localStorage.getItem("userId");

                let newPollObj = {};
                newPollObj.id = newObj;
                newPollObj[selectedOption] = selectedOption;
                arr[indexOfObject] = newPollObj;
              } else {
                let newPollObj = {};
                newPollObj.id = localStorage.getItem("userId");
                newPollObj[selectedOption] = selectedOption;
                arr.push(newPollObj);
              }

              let pollCountData = {
                pollcount_id: pollcountid,
                polls_id: pollObject.poll_id,
                pollobj: arr,
              };

              makePostRequest("polls/updatePollCount", pollCountData)
                .then((response) => {
                  if (response.data.status === "1") {
                    // swal("Success", "Group created successfully", "success", {
                    //   timer: 1000,
                    //   buttons: false,
                    // });
                    setSelectedOption("");
                    // setIsUserVoted(true);
                    getAllpolls();
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });
            } else {

              // not present
              let arrOptionSelected = [];
              let newPollObj = {};
              newPollObj.id = localStorage.getItem("userId");
              newPollObj[selectedOption] = selectedOption;

              arrOptionSelected.push(newPollObj);
              let pollCountData = {
                // pollcount_id:pollObject.pollcount_id,
                polls_id: pollObject.poll_id,
                pollobj: arrOptionSelected,
              };

              makePostRequest("polls/insertcount", pollCountData)
                .then((response) => {
                  if (response.data.status === "1") {
                    setSelectedOption("");
                    // setIsUserVoted(true);
                    // setUpdate(!Update);
                    getAllpolls();
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });
            }
            // setnoticeTitle(response.data.data.notice_title);


          } else {

            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {

          swal("There was an error!", "more error details", "warning");
        });


      // if (pollObject.pollcount_id) {
      //   console.log('in if')
      //   return
      //   arr = pollObject.pollobj;

      //   const obj = arr.find((item) => item.hasOwnProperty(selectedOption));
      //   if (obj) {
      //     let indexOfObject = pollObject.pollobj.indexOf(obj);
      //     let newObj = obj.id + "," + localStorage.getItem("userId");

      //     let newPollObj = {};
      //     newPollObj.id = newObj;
      //     newPollObj[selectedOption] = selectedOption;
      //     arr[indexOfObject] = newPollObj;
      //   } else {
      //     let newPollObj = {};
      //     newPollObj.id = localStorage.getItem("userId");
      //     newPollObj[selectedOption] = selectedOption;
      //     arr.push(newPollObj);
      //   }

      //   let pollCountData = {
      //     pollcount_id: pollObject.pollcount_id,
      //     polls_id: pollObject.poll_id,
      //     pollobj: arr,
      //   };

      //   await makePostRequest("polls/updatePollCount", pollCountData)
      //     .then((response) => {
      //       if (response.data.status === "1") {
      //         // swal("Success", "Group created successfully", "success", {
      //         //   timer: 1000,
      //         //   buttons: false,
      //         // });
      //         setSelectedOption("");
      //         // setIsUserVoted(true);
      //         getAllpolls();
      //       }
      //     })
      //     .catch((err) => {
      //       swal("There was an error!", "more error details", "warning");
      //     });
      // } else {
      //   console.log('in else')
      //   return
      //   //Create PollCount Object and add vote

      //   let arrOptionSelected = [];
      //   let newPollObj = {};
      //   newPollObj.id = localStorage.getItem("userId");
      //   newPollObj[selectedOption] = selectedOption;

      //   arrOptionSelected.push(newPollObj);
      //   let pollCountData = {
      //     // pollcount_id:pollObject.pollcount_id,
      //     polls_id: pollObject.poll_id,
      //     pollobj: arrOptionSelected,
      //   };

      //   await makePostRequest("polls/insertcount", pollCountData)
      //     .then((response) => {
      //       if (response.data.status === "1") {
      //         setSelectedOption("");
      //         // setIsUserVoted(true);
      //         // setUpdate(!Update);
      //         getAllpolls();
      //       }
      //     })
      //     .catch((err) => {
      //       swal("There was an error!", "more error details", "warning");
      //     });
      // }
    } else {
      // alert('cancel')
      setSelectedOption("");
      // setupdate(!update)
    }
  }


  const handleChangeTabs = (flag) => {
    setCurrentPage(1);
    setStatus(flag);
  };
  React.useEffect(() => {
    getAllpolls(status);
  }, [q, sort, status, currentPage]);

  React.useEffect(() => {
    if (ressearch) {
      residentlisting();
    }
  }, [ressearch, membersIds]);

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Polls</h1>
            <Button
              className="contentTopLefBt"
              onClick={handleClickOpen2("body")}
            >
              Create Poll
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="complaintsTbMain pollMasterMain">
              <div className="invoicePaidUnpaidTabMain">
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                    >
                      <Tab
                        label="Open polls"
                        {...a11yProps(0)}
                        onClick={() => handleChangeTabs("open")}
                      />
                      <Tab
                        label="Close polls"
                        {...a11yProps(1)}
                        onClick={() => handleChangeTabs("close")}
                      />
                    </Tabs>
                  </Box>

                  <div className="visitorSearch visitorSearchForPolls">
                    <div className="visitorSearchInr">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search"
                          onChangeCapture={(e) => setQ(e.target.value)}
                        />
                      </div>
                      <SortIcon
                        className="visitorFilterIco"
                        aria-controls={openMenu ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : undefined}
                        onClick={handleClick}
                      />
                    </div>
                  </div>

                  {/* for open poll */}
                  <TabPanel value={value} index={0}>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleCloseMenu}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={handleCloseMenu}
                        data-my-value={"newtoold"}
                      >
                        Newest to Oldest
                      </MenuItem>

                      <MenuItem
                        onClick={handleCloseMenu}
                        data-my-value={"oldtonew"}
                      >
                        Oldest to Newest
                      </MenuItem>
                    </Menu>
                    <div className="pollsPageMain pollsPageMain2">
                      {pollsList.length > 0 ? (
                        <>
                          {pollsList.map((option) => (
                            <div
                              className="parkSocityInner"
                              key={option.poll_id}
                            >
                              <div className="parkSocityTop">
                                <div className="parkSocityTopPro">
                                  {option.profile_pic ? (
                                    <Zoom>
                                      <img src={option.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <Zoom>
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    </Zoom>
                                  )}
                                </div>
                                <div className="pollConTopDiv">
                                  <div>
                                    <h4>
                                      {option.fname} {option.lname}
                                    </h4>
                                    <div className="parkWi">
                                      <b>{option.contact_no}</b>
                                    </div>
                                  </div>

                                  <div>
                                    <h4>Poll open time</h4>
                                    <div className="parkWi">
                                      <b>
                                        {moment(
                                          option.poll_start_datetime
                                        ).format("DD-MM-YYYY h:mm:ss a")}
                                      </b>
                                    </div>
                                  </div>
                                  <div>
                                    <h4>Poll close time</h4>
                                    <div className="parkWi">
                                      <b>
                                        {moment(
                                          option.poll_expiry_datetime
                                        ).format("DD-MM-YYYY h:mm:ss a")}
                                      </b>
                                    </div>
                                  </div>
                                  {option.pollcount_id ? (
                                    <>
                                      {option.pollobj[0].id.includes(
                                        localStorage.getItem("userId")
                                      ) ? (
                                        <h4 className="votedSt">
                                          Voted<HowToVoteIcon />
                                        </h4>
                                      ) : (
                                        <>
                                          {option.pollobj.length > 1 ? (
                                            <>
                                              {option.pollobj[1].id.includes(
                                                localStorage.getItem("userId")
                                              ) ? (
                                                <>
                                                  <h4 className="votedSt">
                                                    Voted <HowToVoteIcon />
                                                  </h4>
                                                </>
                                              ) : (
                                                <>
                                                  <div>
                                                    <h4
                                                      className="votSt"
                                                      onClick={() =>
                                                        AddPollVote(option)
                                                      }
                                                    >
                                                      Vote Now
                                                    </h4>
                                                    {new Date(
                                                      option.poll_start_datetime
                                                    ) < new Date() && (
                                                        <div className="parkWi">
                                                          <b className="closingSt">
                                                            Closing soon
                                                          </b>
                                                        </div>
                                                      )}
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <div>
                                                <h4
                                                  className="votSt"
                                                  onClick={() =>
                                                    AddPollVote(option)
                                                  }
                                                >
                                                  Vote Now
                                                </h4>
                                                {new Date(
                                                  option.poll_start_datetime
                                                ) < new Date() && (
                                                    <div className="parkWi">
                                                      <b className="closingSt">
                                                        Closing soon
                                                      </b>
                                                    </div>
                                                  )}
                                              </div>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <div>
                                      <h4
                                        className="votSt"
                                        onClick={() => AddPollVote(option)}
                                      >
                                        Vote Now
                                      </h4>
                                      {new Date(option.poll_start_datetime) <
                                        new Date() && (
                                          <div className="parkWi">
                                            <b className="closingSt">
                                              Closing soon
                                            </b>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="parContTxOuter">
                                <p className="parContTx">{option.polltopic}</p>
                                <p className="discutionSmallContTx">
                                  {option.description}
                                </p>
                              </div>
                              {!(
                                option &&
                                option.pollobj &&
                                Array.isArray(option.pollobj) &&
                                option.pollobj
                                  .map((obj) => obj.id)
                                  .includes(localStorage.getItem("userId"))
                              ) && (
                                  <div className="prograssMain myPollRadio">
                                    <RadioGroup
                                      onChange={(e) => handleChangeOption(e)}
                                    >
                                      {option.poll_option ? (
                                        <>
                                          {option.poll_option.map((key) => (
                                            <span className="progRadio" key={key}>
                                              <FormControlLabel
                                                value={key}
                                                control={<Radio />}
                                                label={key}
                                              />
                                            </span>
                                          ))}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </RadioGroup>
                                  </div>
                                )}
                            </div>
                          ))}
                        </>
                      ) : (
                        // <div className="Available">
                        //   No Open Polls Available....
                        // </div>
                        <div className="recordNotFound reduceSize">
                          <img src={reecordNotFound} />
                        </div>
                      )}
                    </div>
                  </TabPanel>

                  {/* for close poll */}
                  <TabPanel value={value} index={1}>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleCloseMenu}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={handleCloseMenu}
                        data-my-value={"newtoold"}
                      >
                        Newest to Oldest
                      </MenuItem>

                      <MenuItem
                        onClick={handleCloseMenu}
                        data-my-value={"oldtonew"}
                      >
                        Oldest to Newest
                      </MenuItem>
                    </Menu>
                    <div className="pollsPageMain pollsPageMain2">
                      {pollsList.length > 0 ? (
                        <>
                          {pollsList.map((option, index) => (
                            <>
                              <div className="parkSocityInner">
                                <div className="parkSocityTop">
                                  <div className="parkSocityTopPro">
                                    {option.profile_pic ? (
                                      <Zoom>
                                        <img src={option.profile_pic} />
                                      </Zoom>
                                    ) : (
                                      <Zoom>
                                        <img alt="Remy Sharp" src={avtarPic} />
                                      </Zoom>
                                    )}
                                  </div>
                                  <div className="pollConTopDiv">
                                    <div>
                                      <h4>
                                        {" "}
                                        {option.fname} {option.lname}
                                      </h4>
                                      <div className="parkWi">
                                        <b>{option.contact_no}1</b>
                                      </div>
                                    </div>

                                    <div>
                                      <h4>Poll open time</h4>
                                      <div className="parkWi">
                                        <b>
                                          {" "}
                                          {moment(
                                            option.poll_start_datetime
                                          ).format("DD-MM-YYYY h:mm:ss a")}
                                        </b>
                                      </div>
                                    </div>
                                    <div>
                                      <h4>Poll close time</h4>
                                      <div className="parkWi">
                                        <b>
                                          {" "}
                                          {moment(
                                            option.poll_expiry_datetime
                                          ).format("DD-MM-YYYY h:mm:ss a")}
                                        </b>
                                      </div>
                                    </div>
                                    <div>
                                      <h4
                                        className="votSt"
                                        onClick={() =>
                                          viewRsltClick(
                                            option.poll_id,
                                            option.polltopic,
                                            index
                                          )
                                        }
                                      >
                                        View Result
                                      </h4>
                                      <div className="parkWi">
                                        <b className="closingSt">Closed</b>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="parContTxOuter">
                                  <p className="parContTx">
                                    {option.polltopic}
                                  </p>
                                  <p className="discutionSmallContTx">
                                    {option.description}
                                  </p>
                                </div>
                                {PollsResultView &&
                                  option.poll_id == getPoll_id && (
                                    <div
                                      className="pollResultDiv"
                                      id={"myResult" + index}
                                    >
                                      <div className="poll_1">
                                        <CheckIcon /> Yes
                                      </div>
                                      <div className="poll_2">No</div>
                                      <Grid container spacing={3}>
                                        {getGraph.length > 0 ? (
                                          <Grid item xs={12} md={12}>
                                            <div>
                                              <h4
                                                className="votSt votStGrap"
                                                onClick={() =>
                                                  voteDetails(option.poll_id)
                                                }
                                              >
                                                Vote details {option.poll_id}
                                              </h4>
                                            </div>
                                          </Grid>
                                        ) : (
                                          <Grid item xs={12} md={12}>
                                            <text className="noVotesAdTx blink_me">
                                              not votes added
                                            </text>
                                          </Grid>
                                        )}

                                        <Grid item xs={12} md={12}>
                                          <div className="pollGraphDiv">
                                            {/* <BarChartPage /> */}
                                            <div className="app">
                                              <div className="row">
                                                <div className="mixed-chart">
                                                  {/* <Chart
                                                options={chartData.options} series={chartData.series} type="bar" 
                                                width={500} 
                                              /> */}

                                                  {/* <BarChartPage chartData={BarChartData} /> */}
                                                  <Bar
                                                    data={BarChartData}
                                                    options={{
                                                      title: {
                                                        display: true,
                                                        text: "Votes",
                                                        fontSize: 20,
                                                      },
                                                      legend: {
                                                        display: true,
                                                        position: "right",
                                                      },
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  )}
                              </div>
                            </>
                          ))}
                        </>
                      ) : (
                        // <div className="Available">
                        //   No Close Polls Available....
                        // </div>
                        <div className="recordNotFound reduceSize">
                          <img src={reecordNotFound} />
                        </div>
                      )}
                    </div>
                  </TabPanel>
                </Box>

                <Grid container spacing={3} >
                  <Grid item xs={12} md={12} >
                    <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded" />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* //Modal Box for create poll  Start */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create Poll</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={createPole}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3} className="addCommitee1">
                        <Grid item xs={12} md={12}>
                          <div className="modalInput">
                            <SmsOutlinedIcon />
                            <input
                              maxLength={255}
                              className="modalInputSt"
                              placeholder="Topic"
                              value={values.poleTopic}
                              onChange={handleChange("poleTopic")}
                              onBlur={() => setFieldTouched("poleTopic")}
                              onChangeCapture={(e) =>
                                setPoleTopic(e.target.value)
                              }
                            />
                          </div>
                          {errors.poleTopic && touched.poleTopic ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.poleTopic}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <div className="modalInput">
                            <textarea
                              className="textAriaSt"
                              placeholder="Poll description"
                              value={values.poleDesc}
                              onChange={handleChange("poleDesc")}
                              onBlur={() => setFieldTouched("poleDesc")}
                              onChangeCapture={(e) =>
                                setPoleDesc(e.target.value)
                              }
                            />
                          </div>
                          {errors.poleDesc && touched.poleDesc ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.poleDesc}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <div className="pollOptionMain">
                            <h3 className="pollOptionHed">
                              <p>Poll Options</p>{" "}
                            </h3>
                            <div className="pollOptionHedAdd">
                              <ul id="myList">
                                <li>
                                  <div className="pollOptionHedAddInput">
                                    <input
                                      className="modalInputStSelect"
                                      value={values.option1}
                                      onChange={handleChange("option1")}
                                      onBlur={() => setFieldTouched("option1")}
                                      onChangeCapture={(e) =>
                                        setOption1(e.target.value)
                                      }
                                      disabled
                                    />
                                    {/* <CloseOutlinedIcon /> */}
                                    {errors.option1 && touched.option1 ? (
                                      <div
                                        style={{ color: "red" }}
                                        className="errorField"
                                      >
                                        {errors.option1}
                                      </div>
                                    ) : null}
                                  </div>
                                </li>
                                <li>
                                  <div className="pollOptionHedAddInput">
                                    <input
                                      className="modalInputStSelect"
                                      value={values.option2}
                                      onChange={handleChange("option2")}
                                      onBlur={() => setFieldTouched("option2")}
                                      onChangeCapture={(e) =>
                                        setOption2(e.target.value)
                                      }
                                      disabled
                                    />
                                    {/* <CloseOutlinedIcon /> */}
                                    {errors.option2 && touched.option2 ? (
                                      <div
                                        style={{ color: "red" }}
                                        className="errorField"
                                      >
                                        {errors.option2}
                                      </div>
                                    ) : null}
                                  </div>
                                </li>

                                {[...Array(count)].map((_, i) => (
                                  <AddedElement key={i} />
                                ))}
                              </ul>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="labSt">Poll Start Date</label>
                          <div className="openNewDayNHrsMain">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                disablePast
                                className="modalInputStSelect"
                                value={poleStartDate}
                                onChange={handleChangePoleStartDate}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="labSt">Poll Expiry Date</label>
                          <div className="openNewDayNHrsMain">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                disablePast
                                className="modalInputStSelect"
                                value={poleEndDate}
                                onChange={handleChangePoleEndDate}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <label className="labSt">Visible to</label>
                          <div
                            className="radioGroupNew"
                            onChange={(e) => handleChangeradio(e)}
                          >
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                              >
                                <FormControlLabel
                                  value="all"
                                  control={<Radio />}
                                  label="All"
                                />
                                <FormControlLabel
                                  value="committeeMembers"
                                  control={<Radio />}
                                  label="Committee Members"
                                />
                                <FormControlLabel
                                  value="allOwners"
                                  control={<Radio />}
                                  label="All Owners"
                                />
                                <FormControlLabel
                                  value="Groups"
                                  control={<Radio />}
                                  label="Group"
                                />
                              </RadioGroup>
                              {errmsgradiobtn ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {"Required"}
                                </div>
                              ) : null}
                            </FormControl>
                          </div>
                        </Grid>

                        {isSelectGroup ? (
                          <Grid item xs={12} md={12}>
                            <div className="refreshOut">
                              <select
                                className="modalInputStSelect"
                                value={selectedGroup}
                                onChange={handleChangeGroup}
                              >
                                <option>Select Group</option>
                                {groupsList.length > 0 ? (
                                  <>
                                    {groupsList.map((option) => (
                                      <option
                                        key={option.group_id}
                                        value={option.group_id}
                                        data-isd={option.group_name}
                                      >
                                        {option.group_name}
                                      </option>
                                    ))}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </select>
                              {showerr ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {"Required"}
                                </div>
                              ) : null}
                              <div className="refreshList">
                                <ReplayCircleFilledIcon />
                              </div>
                            </div>
                            <div className="orDivider">
                              <span>OR</span>
                            </div>
                            <div className="cretaeGroupLink">
                              <a onClick={handleClickOpen3("body")}>
                                Create New Group
                              </a>
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}
                        <Grid item xs={12} md={12}>
                          <div className="modalMainBtMain">
                            <Button className="modalMainBt" type="submit">
                              Start Poll
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Created Poll successfully</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* //Modal Box for create poll  End */}

      {/*Create Group Madal */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose3}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="groupModal"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create New Group</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Name</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Name"
                    value={group_name}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Description</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Description"
                    value={group_description}
                    onChange={(e) => setGroupDesc(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Add Members in a group</label>
                  <div className="searchOut">
                    <div className="modalInput">
                      <SearchIcon />
                      <input
                        className="modalInputSt"
                        placeholder="Search Members"
                        onChangeCapture={(e) => setressearch(e.target.value)}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="visitContDivScroll">
                    {residentlist.map((option) => (
                      <div
                        key={option.resident_id}
                        className={
                          membersIds.includes(option.resident_id)
                            ? "visitContDiv visitContDivNotice selectedTile draftSection"
                            : "visitContDiv visitContDivNotice draftSection"
                        }
                        onClick={() =>
                          handleChangeSelectedResident(option.resident_id)
                        }
                      >
                        <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                          {option.apartment ? (
                            <>
                              {/* {option.apartment.} */}
                              {option.apartment.map((resApt, index) => (
                                <>
                                  {resApt.is_current_stay == true &&
                                    (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                    // {setTempCurrentStay(true)}
                                    <div className="NewTailCountOut miniBox">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[0]}
                                        </p>
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[1]}
                                        </p>
                                      </div>
                                      <h1>
                                        {resApt.uniq_apt_name.split("/")[2]}
                                      </h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ))}
                              {option.currentstaycnt.count == 0 &&
                                (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                <div className="NewTailCountOut defaultTailCount miniBox">
                                  <div className="buildingNameNcount">
                                    <p>No Apart.</p>
                                    <p>Occupied</p>
                                  </div>
                                  <h1>F-000</h1>
                                </div>
                              ) : (
                                <></>
                              )}

                              {option.user_type == "tenent" && (
                                <>
                                  {option.apartment.map((resApt, index) => (
                                    <div className="NewTailCountOut miniBox">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[0]}
                                        </p>
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[1]}
                                        </p>
                                      </div>
                                      <h1>
                                        {resApt.uniq_apt_name.split("/")[2]}
                                      </h1>
                                    </div>
                                  ))}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="NewTailCountOut defaultTailCount miniBox">
                                <div className="buildingNameNcount">
                                  <p>No Apart.</p>
                                  <p>Occupied</p>
                                </div>
                                <h1>F-000</h1>
                              </div>
                            </>
                          )}

                          <div className="visitContProf">
                            {option.user_obj.profile_pic ? (
                              <Zoom>
                                <img src={option.user_obj.profile_pic} />
                              </Zoom>
                            ) : (
                              <img alt="Remy Sharp" src={avtarPic} />
                            )}
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {option.user_obj.first_name}{" "}
                              {option.user_obj.last_name}{" "}
                            </h3>
                            <p className="visitContMob">
                              {option.user_obj.contact_no}
                            </p>
                          </div>

                          <div className="visitBottCont forMyTexAlign">
                            {option.apartment ? (
                              <div>
                                <>
                                  {option.apartment.map((opt) => (
                                    <>
                                      {(opt.is_current_stay == true ||
                                        opt.occupancy_type == "Vacant") &&
                                        (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                        <b className="visitContMob">
                                          {opt.uniq_apt_name}
                                          <em>{opt.occupancy_type}</em>
                                          <br />
                                        </b>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ))}
                                </>

                                {option.user_type == "tenent" && (
                                  <>
                                    {option.apartment.map((opt1, index) => (
                                      <b className="visitContMob">
                                        {opt1.uniq_apt_name}
                                        <em>{opt1.occupancy_type}</em>
                                      </b>
                                    ))}
                                  </>
                                )}
                              </div>
                            ) : (
                              <div>No Apartment Allocated</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {showerr ? (
                    <div style={{ color: "red" }} className="errorField">
                      {"Required"}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button
                      className="modalMainBt"
                      onClick={() => createGroup()}
                    >
                      {" "}
                      Create Group{" "}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="pollResulModMain"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Poll Result</span>
            <h4>{polltitle}</h4>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>

          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div className="pollResultMain">
                <div className="pollResultContDiv">
                  <h3 className="pollResultContTop">
                    <span>Yes vote</span>
                    <b>{graphdetilData.yesdata.length}</b>
                  </h3>
                  {graphdetilData.yesdata.length > 0 ? (
                    <>
                      {graphdetilData.yesdata.map((item) => (
                        <div className="pollResultInerContDiv">
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <div className="pollResultInerContpro">
                                <div className="pollResultProDi">
                                  {item.profile_pic ? (
                                    <Zoom>
                                      <img src={item.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <Zoom>
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    </Zoom>
                                  )}
                                </div>
                                <h2>
                                  {item.fname} {item.lname}
                                </h2>

                                {item.user_type == "tenent" && (
                                  <span>{item.uniq_apt_name[0]}</span>
                                )}
                                {item.user_type == "Resident User" && (
                                  <span>{item.uniqaptname}</span>
                                )}
                                {item.user_type == "SocietyAdmin" && (
                                  <span>NA</span>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      ))}
                    </>
                  ) : (
                    <text>No vote for yes</text>
                  )}
                </div>
                <div className="pollResultContDiv">
                  <h3 className="pollResultContTop">
                    <span>No vote</span>
                    <b>{graphdetilData.nodata.length}</b>
                  </h3>

                  {graphdetilData.nodata.length > 0 ? (
                    <>
                      {graphdetilData.nodata.map((item) => (
                        <div className="pollResultInerContDiv">
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <div className="pollResultInerContpro">
                                <div className="pollResultProDi">
                                  {item.profile_pic ? (
                                    <Zoom>
                                      <img src={item.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <Zoom>
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    </Zoom>
                                  )}
                                </div>
                                <h2>
                                  {item.fname} {item.lname}
                                </h2>
                                {item.user_type == "tenent" && (
                                  <span>{item.uniq_apt_name[0]}</span>
                                )}
                                {(item.user_type == "Resident User" || item.user_type == "Admin Owner") && (
                                  <span>{item.uniqaptname}</span>
                                )}
                                {item.user_type == "SocietyAdmin" && (
                                  <span>NA</span>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      ))}
                    </>
                  ) : (
                    <text>No vote for no</text>
                  )}
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader && (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      )}
    </>
  );
}

export default PollsPage;
